import { cn } from "@/lib/utils";
import { Copy, Check } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

interface CodeBlockProps {
  value: string;
  className?: string;
  label?: string;
  maxHeight?: string;
}

export function CodeBlock({
  value,
  className,
  label,
  maxHeight = "200px",
}: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className={cn("relative group", className)}>
      {label && (
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            {label}
          </span>
        </div>
      )}
      <div className="relative">
        <pre
          className={cn(
            "bg-code-bg border border-code-border rounded-lg p-4 overflow-auto font-mono text-xs leading-relaxed text-foreground",
            "scrollbar-thin scrollbar-thumb-border scrollbar-track-transparent"
          )}
          style={{ maxHeight }}
        >
          {value || (
            <span className="text-muted-foreground italic">
              Response will appear here...
            </span>
          )}
        </pre>
        {value && (
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-2 right-2 h-8 w-8 opacity-0 group-hover:opacity-100 transition-opacity bg-background/80 backdrop-blur-sm"
            onClick={handleCopy}
          >
            {copied ? (
              <Check className="h-4 w-4 text-success" />
            ) : (
              <Copy className="h-4 w-4" />
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
